import * as zip from "@zip.js/zip.js";
import xml2js from "xml2js";

import { toast } from 'vue3-toastify';
import { copyObject } from "@/utils/Utils.js";
import { KeyAction, diversKeys, TemplateSuitePayloadParam, TemplateActionsGroup, TemplateActionTrigger } from  '@/utils/constant/flight_actions_constantes' ;
import { CamSettings } from  '@/utils/constant/flight_settings_constantes' ;
import { v4 as uuidv4 } from "uuid";

import API from "@/utils/API.js";
import ApiActions from "@/utils/map/Map_FlightActions";

class FlightKmz {

  template;
  waylines;
  noTags;

  constructor() {
    this.template = undefined;
    this.waylines = undefined;
    this.noTags = ['kml', '$', 'xmlns', 'xmlns:wpml', 'Document', 'Folder', 'Placemark', 'Point', 'coordinates'];

    this.extension =  ".kmz";

  }

  getTemplate() {
    return this.template;
  }

  getWaylines(){
    return this.waylines;
  }

  async load(misid) {
    let blob = await API.fetchBlob("missionfile?&MisId=" + misid);
    if(blob !== null && blob !== undefined) {
      return await this.kmz2Json(blob);
    }
  }

  async download(misid, mistxt) {
    let mission_file = await API.fetchBlob("missionfile?&MisId=" + misid);
    if(mission_file !== null && mission_file !== undefined) {
      let url = window.URL.createObjectURL(mission_file);

      //create a hidden link and set the href and click it
      let a = document.createElement("a");
      a.style = "display: none";
      a.href = url;
      a.download = mistxt;
      a.click();
      window.URL.revokeObjectURL(url);
      return;
    }
  }

  prepareToWrite(templatekmz, infos, mission_id, nameFile){
    let newTemplate = copyObject(templatekmz);
    newTemplate = this.traitementTemplate(newTemplate, infos)

    // pour Waylines, on part d'une copie de Template et on va clean/add les tags nécessaire
    // les index seront déjà à jourà ce niveau là, idem pr l'infra
    let newWayline = copyObject(newTemplate);
    newWayline = this.traitementWayline(newWayline, templatekmz, infos)

    // save via API
    this.save(newTemplate, newWayline, mission_id, nameFile);

  }



  async save(template, waylines, misid, nameFile){
    template =  this.encodeJsonCoords(template);
    waylines = this.encodeJsonCoords(waylines);

    const xmltemplate = this.jsonToXML(template);
    const xmlwaylines = this.jsonToXML(waylines);

    //console.log(xmltemplate);
    //console.log(xmlwaylines);

    const kmz = await this.xml2Kmz(xmltemplate, xmlwaylines,  nameFile );

    if(kmz != undefined) {
      let response = await API.putFile(`missionfile?mis_id=${misid}`, kmz);
      if (response.Result === ENV.API_RESPONSE_VALID) {
        toast.success("Le vol a bien été sauvegardé.", $root.toastConfig);
      }
      else{
        toast.error("Erreur lors de l'enregistrement du vol.", $root.toastConfig);
      }
    }
  }

  traitementTemplate(template, infos){
    template.kml.Document.updateTime = Date.now();

    let lstPlacemark = this.getPlacemark(template);
    if(lstPlacemark !== null && lstPlacemark !== undefined && lstPlacemark.length > 0){
      // dans un premier temps, on parcours les Placemark pr définir les actionGroupEndIndex des éventuels IntervalShot
      lstPlacemark.forEach((placemark, idx) => {
        // on parcours tous les actionGroup définis
        // dès que l'on tombe sur un IntevalShot => on chreche où mettre le End
        placemark.actionGroup.forEach((actgrp)=>{
          if(actgrp.actionTrigger.actionTriggerType !== diversKeys.keyTriggerReach){
            this.getIntervalShotGroupIdEnd(actgrp, lstPlacemark);
            // console.log(actgrp)
          }
          else if(actgrp.action.actionActuatorFunc === KeyAction.snapshotfixedangle) {
            //supprimer les sauvegardes
            if(actgrp.action.actionActuatorFuncParamSave) {
              delete actgrp.action.actionActuatorFuncParamSave;
            }
            //reseigner orientedShoot
            if(actgrp.action.actionActuatorFuncParam.actionUUID === "") {
              actgrp.action.actionActuatorFuncParam.actionUUID = uuidv4();
            }
            if(actgrp.action.actionActuatorFuncParam.orientedFilePath === "") {
              actgrp.action.actionActuatorFuncParam.orientedFilePath = uuidv4();
            }
            if(actgrp.action.actionActuatorFuncParam.orientedCameraType === "") {
              actgrp.action.actionActuatorFuncParam.orientedCameraType = template.kml.Document.missionConfig.payloadInfo.payloadEnumValue;
            }

            actgrp.actionGroupEndIndex = actgrp.actionGroupStartIndex;
          }
          else{
            actgrp.actionGroupEndIndex = actgrp.actionGroupStartIndex;
          }
        })

      })



      lstPlacemark.forEach((placemark, idx) => {
        placemark = this.updateTemplatePlacemarkValues(placemark, infos[idx]);


        // comparer la speed du placemark, avec celle "globale", si différente => retirer la clé useGlobalSpeed du Placemark
        const placeSpeed = parseFloat(infos[idx].speed);
        const globalSpeed = parseFloat(template.kml.Document.Folder.autoFlightSpeed);
        if(placeSpeed !== globalSpeed){
          delete placemark.useGlobalSpeed;
        }
        else{
          placemark.useGlobalSpeed = 1;
        }



        // reorder des actions, pour avoir toutes les action en trigger 'reachPoint' au début
        this.reorderAction(placemark);
        // console.log(placemark);
      })

      /// A REVOIR
      lstPlacemark = this.updateIDWrite(lstPlacemark);
      this.setPlacemark( template, lstPlacemark);
      // console.log("placemark apres recalcul ID", lstPlacemark);

    }

    return template;
  }

  updateTemplatePlacemarkValues(placemark, infos){
    placemark.Point.coordinates = [infos.coordinates.longitude, infos.coordinates.latitude ];
    placemark.ellipsoidHeight = parseFloat(infos.coordinates.height).toFixed(2);
    placemark.height = parseFloat(infos.height).toFixed(2);
    placemark.waypointSpeed = infos.speed;

    // si pas présent , on met la valeur par défaut du "non risqué"
    if(placemark.isRisky === undefined || placemark.isRisky === null)
      placemark.isRisky = 0

    return placemark;
  }





  getIntervalShotGroupIdEnd(itemActGroup, lstPlacemarks ){
    let waitingStopInterval = true
    let isIntervalActive = true
    let isLast = false

    for(let placemark in lstPlacemarks){
      for(let actgrp in lstPlacemarks[placemark].actionGroup){

        if(parseInt(lstPlacemarks[placemark].actionGroup[actgrp].actionGroupId) <= parseInt(itemActGroup.actionGroupId)){
          // on skip
          isLast = true
        }
        else{
          isLast = false;

          if(lstPlacemarks[placemark].actionGroup[actgrp].actionTrigger.actionTriggerType === diversKeys.keyTriggerReach){
            if( lstPlacemarks[placemark].actionGroup[actgrp].action.actionActuatorFunc !== diversKeys.keyEndShot){
              // cas où un takePhoto est présent, avec un IntervalShot déclenché en amont, et pas de stopIntervalShot
              // on arrête notre IntervalShot à cette ligne
              if(lstPlacemarks[placemark].actionGroup[actgrp].action.actionActuatorFunc === KeyAction.snapshot && isIntervalActive === true && waitingStopInterval === true ){
                itemActGroup.actionGroupEndIndex = lstPlacemarks[placemark].index
                return true;
              }
            }
            else{
              // cas où un StopIntervalShot
              // si un IntevalShot est lancé
              itemActGroup.actionGroupEndIndex = lstPlacemarks[placemark].index
              return true;
            }
          }
          else{
            // si on trouve un nouveau IntervalShot alors qu'un est déjà en cours
            itemActGroup.actionGroupEndIndex = lstPlacemarks[placemark].index
            return true;
          }
        }

      }
    }

    // cas où le IntervalShot était le dernier item
    // Start = End
    if(isLast === true ){
      itemActGroup.actionGroupEndIndex = itemActGroup.actionGroupStartIndex
      return true;
    }
    else{
      // cas où il y a eu d'autres actions, mais totues en 'reachPoint'
      // on met le End sur le dernier step
      itemActGroup.actionGroupEndIndex = lstPlacemarks[lstPlacemarks.length - 1].index
      return true;
    }
  }



  reorderAction(placemark){
    let arrActGrpNewOrder = new Array();
    let arrReachPt = new Array();
    let itmActGrpDefault = null;

    if(placemark !== undefined && placemark !== null && placemark.actionGroup !== undefined && placemark.actionGroup !==null){
      if(Array.isArray(placemark.actionGroup)){

        placemark.actionGroup.forEach((itemActGrp)=>{
          if(itemActGrp !== undefined && itemActGrp !== null && itemActGrp.action !== undefined && itemActGrp.action !== null ){
            // en 1er on garde ensemble toutes les actions 'reachPoint'
            if(itemActGrp.actionTrigger.actionTriggerType === diversKeys.keyTriggerReach){
              // on skip si il s'agit de l'action "endShot" => pas d'existence dans le KMZ, mais uniquement graphiquement dans le tableau
              if( itemActGrp.action.actionActuatorFunc !== diversKeys.keyEndShot){
                arrReachPt.push(itemActGrp.action);
              }

              // on stocke les tag du actionGroupe 'reachPoint'
              if(itmActGrpDefault === null)
                itmActGrpDefault = itemActGrp;
            }
            else{
              arrActGrpNewOrder.push(itemActGrp);
            }
          }
        })

        if(arrReachPt.length > 0 ){
          itmActGrpDefault.action = arrReachPt;
          arrActGrpNewOrder.unshift(itmActGrpDefault);
        }
      }
      else{
        // console.log('reorder NO ARRAY ACTIONGROUP');
      }


      placemark.actionGroup = arrActGrpNewOrder;

    }
  }



  traitementWayline(wayline, templatekmz, infos){
    // traiter le cas où on n'a plus aucun Placemark => Folder à suppr
    // pour ça on se base sur l'obj KMZ que l'on modifie dans l'ui
    let lstPlacemark = this.getPlacemark(wayline);
    if(lstPlacemark === null || lstPlacemark === undefined || lstPlacemark.length === 0)
      delete wayline.kml.Document.Folder;

    // en 1er on vérifie que certains tags ne sont pas présent
    this.cleanTagWayline(wayline);

    // en 2nd on ajoute/update les valeurs des tags à garder
    // on prend la ref du KMZ template pour reporter certaines dans le KMZ de Waylines
    this.addTagWayline(wayline, templatekmz, infos);

    return wayline
  }


  cleanTagWayline(wayline){
    if(wayline) {
      try{
        if(wayline.kml.Document !== undefined){
          delete wayline.kml.Document.author;
          delete wayline.kml.Document.createTime;
          delete wayline.kml.Document.updateTime;

          if(wayline.kml.Document.missionConfig !== undefined){
            delete wayline.kml.Document.missionConfig.takeOffRefPoint;
            delete wayline.kml.Document.missionConfig.takeOffRefPointAGLHeight;
          }

          if(wayline.kml.Document.Folder !== undefined){
            delete wayline.kml.Document.Folder.payloadParam;
            delete wayline.kml.Document.Folder.templateType;
            delete wayline.kml.Document.Folder.waylineCoordinateSysParam;
            delete wayline.kml.Document.Folder.globalHeight;
            delete wayline.kml.Document.Folder.caliFlightEnable;
            delete wayline.kml.Document.Folder.gimbalPitchMode;
            delete wayline.kml.Document.Folder.globalWaypointHeadingParam;
            delete wayline.kml.Document.Folder.globalWaypointTurnMode;
            delete wayline.kml.Document.Folder.globalUseStraightLine;
          }
        }
      }
      catch(err){
        // console.log('Erreur pendant le nettoyage du fichier Waylines.wpml : ', err);
      }
    }
    return wayline;
  }

  addTagWayline(wayline, templatekmz, infos ){
    if(wayline){
      if(wayline.kml.Document !== undefined && wayline.kml.Document.Folder !== undefined){
        wayline.kml.Document.Folder.executeHeightMode = templatekmz.kml.Document.Folder.waylineCoordinateSysParam.coordinateMode;
        wayline.kml.Document.Folder.waylineId = 0; // change jamais ?
        wayline.kml.Document.Folder.distance = infos.distance;
        wayline.kml.Document.Folder.duration = infos.duration;
      }

      let placemarks = this.getPlacemark(wayline);
      if(placemarks) {
        placemarks.forEach((placemark, idx) => {

          placemark.Point.coordinates = [infos[idx].coordinates.longitude, infos[idx].coordinates.latitude]
          placemark.executeHeight = parseFloat(infos[idx].coordinates.height).toFixed(2);
          placemark.waypointSpeed = infos[idx].speed;
          placemark.waypointHeadingParam.waypointHeadingAngleEnable = 0;
          placemark.waypointTurnParam.waypointTurnDampingDist = 0;

          placemark.useStraightLine = 1;
          placemark.waypointWorkType = 0;

          placemark.waypointGimbalHeadingParam ={
            waypointGimbalPitchAngle : 0,
            waypointGimbalYawAngle : 0
          };

          // si pas présent , on met la valeur par défaut du "non risqué"
          if(placemark.isRisky === undefined || placemark.isRisky === null)
            placemark.isRisky = 0;

          delete placemark.ellipsoidHeight;
          delete placemark.height;
          delete placemark.useGlobalHeight;
          delete placemark.useGlobalSpeed;
          delete placemark.useGlobalHeadingParam;
          delete placemark.useGlobalTurnParam;


          const lstCamAvail = ApiActions.getLstCameraDrone(templatekmz.kml.Document);
          let lstKeyCams=new Array()
          lstCamAvail.forEach((item)=>{
            lstKeyCams.push(item.key);
          })
          const strCams = lstKeyCams.join(",")
          if(Array.isArray(placemark.actionGroup)){
            placemark.actionGroup.forEach((itemActGrp)=>{

              if(itemActGrp !== undefined && itemActGrp !== null && itemActGrp.action !== undefined && itemActGrp.action !== null ){
                // pour des actions : takePhoto (basique ou Interval), startRecord
                // si action.actionActuatorFuncParam.useGlobalPayloadLensIndex = 1 (on prend par défaut toutes les cam du drone)
                // mettre toutes les cameras dispos de ce drone dans : actionActuatorFuncParam.payloadLensIndex

                if(Array.isArray(itemActGrp.action)){
                  itemActGrp.action.forEach((action)=>{
                    if(action !== undefined && action !== null
                      && (action.actionActuatorFunc === KeyAction.snapshot || action.actionActuatorFunc === KeyAction.startvideo || action.actionActuatorFunc === KeyAction.panorama || action.actionActuatorFunc === KeyAction.snapshotfixedangle)
                      /*&& parseInt(action.actionActuatorFuncParam.useGlobalPayloadLensIndex) === 1 */){
                        action.actionActuatorFuncParam.payloadLensIndex = strCams;
                    }
                  })
                }
                else{
                  if( (itemActGrp.action.actionActuatorFunc === KeyAction.snapshot || itemActGrp.action.actionActuatorFunc === KeyAction.startvideo || itemActGrp.action.actionActuatorFunc === KeyAction.panorama || action.actionActuatorFunc === KeyAction.snapshotfixedangle)
                    /*&& parseInt(itemActGrp.action.actionActuatorFuncParam.useGlobalPayloadLensIndex) === 1*/){
                      itemActGrp.action.actionActuatorFuncParam.payloadLensIndex = strCams;
                  }
                }
              }
            })
          }
        })
      }
    }
  }

  // à l'init d'un vol, on prépare l'obj KMZ qui sera utilisé dans l'interface
  convertToUI(templatekmz){
    // créer un tableau "actionGroup", dont chaque item contient un seul "action"
    // tester si c'est un array => on garde, sinon convertir en tableau et dupliquer les infos dans chaque item
    let objReady = null;

    let lstPlacemark = this.getPlacemark(templatekmz);
    if(lstPlacemark){

      let endIntervalToAppend = new Array()


      lstPlacemark.forEach((itemPlacemark) =>{
        if(itemPlacemark.actionGroup !== null && itemPlacemark.actionGroup !== undefined ){

          let saveLstGrp = [];
          if(Array.isArray(itemPlacemark.actionGroup) === false){
            saveLstGrp.push(itemPlacemark.actionGroup);
          }
          else{
            saveLstGrp = itemPlacemark.actionGroup;
          }

          if(saveLstGrp.length >0 ){
            // cas où plusieurs 'actionGroup' définis dans un Placemark
            // => correspond au cas où l'on a des actions avec trigger différents sur un mm Placemark (ex: hover, gimbal en 'reachPoint' et IntervalShot )

            let lstActGrp = new Array();


            //const saveLstGrp = itemPlacemark.actionGroup;
            saveLstGrp.forEach((actGrp)=>{
              const saveConfigGrp = actGrp;

              if(actGrp.action !== undefined && actGrp.action !== null ){
                // cas où plusieurs actions du mm trigger (reachPoint)
                // => tableau d'actions dans le 'actionGroup'
                let saveLstAction = [];

                if(Array.isArray(actGrp.action) === false){
                  saveLstAction.push(actGrp.action);
                }
                else{
                  saveLstAction = actGrp.action;
                }
                if(saveLstAction.length > 0){
                  // cas où un StopInterval doit être mis sur un step avec mix reachPoint / IntervalShot => doit être mis en premier des 'reachPoint'
                  if(endIntervalToAppend[parseInt(itemPlacemark.index)] !== null && endIntervalToAppend[parseInt(itemPlacemark.index)] !== undefined){
                    lstActGrp.push(endIntervalToAppend[parseInt(itemPlacemark.index)]);
                    delete endIntervalToAppend[parseInt(itemPlacemark.index)]
                  }


                  // il faut le splitter pr créer x actionGroup suppl
                  // traiter les x actions enfant
                  saveLstAction.forEach((action)=>{
                    const newActGrp = Object.assign({}, TemplateActionsGroup, saveConfigGrp);
                    newActGrp.action = action;

                    // avant d'ajouter l'action à la liste, on vérifie qu'il s'agit d'un type géré par l'appli
                    const isTypeActionAvail = ApiActions.isActionExist(newActGrp);

                    if(isTypeActionAvail) {

                      if(action.actionActuatorFunc === "orientedShoot") {
                        //sauvegarder les valeurs pour reset()
                        action.actionActuatorFuncParamSave = action.actionActuatorFuncParam;
                        action.actionActuatorFuncParamSave.isInit = true;
                      }
                      lstActGrp.push(newActGrp);

                    }

                    if(saveConfigGrp.actionTrigger.actionTriggerType  !== diversKeys.keyTriggerReach){
                      let endShotActGrp =  copyObject(TemplateActionsGroup);
                      endShotActGrp.actionTrigger = copyObject(TemplateActionTrigger['']);
                      endShotActGrp.action = { actionId: 0, actionActuatorFunc : diversKeys.keyEndShot };

                      // on doit l'ajouter en fct de la valeur du saveConfigGrp.actionGroupEndIndex
                      // si start = end , on l'ajoute juste après
                      if(parseInt(saveConfigGrp.actionGroupStartIndex) === parseInt(saveConfigGrp.actionGroupEndIndex)){
                        lstActGrp.push(endShotActGrp);
                      }
                      else{
                        // l'ajouter au début du bon step
                        endIntervalToAppend[parseInt(saveConfigGrp.actionGroupEndIndex)] = endShotActGrp
                      }
                    }
                  })
                }
                /*
                else if(!Array.isArray(actGrp.action) && actGrp.actionTrigger.actionTriggerType === diversKeys.keyTriggerReach){
                  // cas où 1 seule action 'reachPoint' dans un step où il y a aussi du IntervalShot

                  // => correspond au cas où 1 seule action définie dans 'actionGroup'
                  const newActGrp = Object.assign({}, TemplateActionsGroup, saveConfigGrp);
                  newActGrp.action = actGrp.action;
                  // avant d'ajouter l'action à la liste, on vérifie qu'il s'agit d'un type géré par l'appli
                  const isTypeActionAvail = ApiActions.isActionExist(newActGrp);

                  // cas où un StopInterval doit être mis sur un step full IntervalShot => doit être mis en premier
                  if(endIntervalToAppend[parseInt(itemPlacemark.index)] !== null && endIntervalToAppend[parseInt(itemPlacemark.index)] !== undefined){
                    lstActGrp.push(endIntervalToAppend[parseInt(itemPlacemark.index)]);
                    delete endIntervalToAppend[parseInt(itemPlacemark.index)]
                  }

                  // on ajoute les actions après l'eventuel StopInteval
                  if(isTypeActionAvail){
                    lstActGrp.push(newActGrp);
                  }
                }
                */
                /*
                else{
                  // cas où 'action' est un Object
                  // => correspond au cas des trigger pour les IntervalShot :
                  // où on a 1 item 'actionGroup' contenant 1 seul item 'action', répété x fois si plusieurs IntervalShot définis pour le Placemark


                  // avant d'ajouter l'action à la liste, on vérifie qu'il s'agit d'un type géré par l'appli
                  const isTypeActionAvail = ApiActions.isActionExist(saveConfigGrp);

                  if(isTypeActionAvail){
                    lstActGrp.push(saveConfigGrp);

                    //dans le cas où la seule action renseignée est un Timed ou Distance Shot => graphiquement on doit ajouter un StopShot
                    if(saveConfigGrp.actionTrigger.actionTriggerType  !== diversKeys.keyTriggerReach){
                      let endShotActGrp =  copyObject(TemplateActionsGroup);
                      endShotActGrp.actionTrigger = copyObject(TemplateActionTrigger['']);
                      endShotActGrp.action = { actionId: 0, actionActuatorFunc : diversKeys.keyEndShot };

                      // on doit l'ajouter en fct de la valeur du saveConfigGrp.actionGroupEndIndex
                      // si start = end , on l'ajoute juste après
                      if(parseInt(saveConfigGrp.actionGroupStartIndex) === parseInt(saveConfigGrp.actionGroupEndIndex)){
                        lstActGrp.push(endShotActGrp);
                      }
                      else{
                        // l'ajouter au début du bon step
                        endIntervalToAppend[parseInt(saveConfigGrp.actionGroupEndIndex)] = endShotActGrp
                      }
                    }
                  }
                }*/
              }
            })

            itemPlacemark.actionGroup = lstActGrp;
          }
          /*
          else{
            // cas où 1 seul 'actionGroup' object dans le Placemark
            // => correspond au cas où toutes les actions sont du mm type de trigger  OU 1 seule action définie



            if(itemPlacemark.actionGroup.action !== undefined && itemPlacemark.actionGroup.action !== null){
              const saveLstActions = itemPlacemark.actionGroup.action;
              delete itemPlacemark.actionGroup.action;

              const saveConfigGrp = itemPlacemark.actionGroup;

              itemPlacemark.actionGroup = new Array()

              // si contient un tableau 'action' (reachPoint)
              // => plusieurs actions du mm type de trigger, regroupées ensemble : hover, gimbal, ....
              if( saveLstActions.length > 0){
                // cas où un StopInterval doit être mis sur un step full reachPoint => doit être mis en premier
                if(endIntervalToAppend[parseInt(itemPlacemark.index)] !== null && endIntervalToAppend[parseInt(itemPlacemark.index)] !== undefined){
                  itemPlacemark.actionGroup.push(endIntervalToAppend[parseInt(itemPlacemark.index)]);
                  delete endIntervalToAppend[parseInt(itemPlacemark.index)]
                }

                // on boucle sur les x actions, pour créer un objet actionGroup autour de chacune
                saveLstActions.forEach((action)=>{
                  const newActGrp = Object.assign({}, TemplateActionsGroup, saveConfigGrp);
                  newActGrp.action = action;

                  // avant d'ajouter l'action à la liste, on vérifie qu'il s'agit d'un type géré par l'appli
                  const isTypeActionAvail = ApiActions.isActionExist(newActGrp);

                  if(isTypeActionAvail)
                    itemPlacemark.actionGroup.push(newActGrp);
                })
              }
              else{
                // cas où un StopInterval doit être mis sur un step full IntervalShot => doit être mis en premier
                if(endIntervalToAppend[parseInt(itemPlacemark.index)] !== null && endIntervalToAppend[parseInt(itemPlacemark.index)] !== undefined){
                  itemPlacemark.actionGroup.push(endIntervalToAppend[parseInt(itemPlacemark.index)]);
                  delete endIntervalToAppend[parseInt(itemPlacemark.index)]
                }


                // => correspond au cas où 1 seule action définie dans 'actionGroup'
                const newActGrp = Object.assign({}, TemplateActionsGroup, saveConfigGrp);
                newActGrp.action = saveLstActions;

                // avant d'ajouter l'action à la liste, on vérifie qu'il s'agit d'un type géré par l'appli
                const isTypeActionAvail = ApiActions.isActionExist(newActGrp);

                if(isTypeActionAvail){
                  itemPlacemark.actionGroup.push(newActGrp);

                  //dans le cas où la seule action renseignée est un Timed ou Distance Shot => graphiquement on doit ajouter un StopShot
                  if(newActGrp.actionTrigger.actionTriggerType  !== diversKeys.keyTriggerReach){
                    let endShotActGrp =  copyObject(TemplateActionsGroup);
                    endShotActGrp.actionTrigger = copyObject(TemplateActionTrigger['']);
                    endShotActGrp.action = { actionId: 0, actionActuatorFunc : diversKeys.keyEndShot };

                    // on doit l'ajouter en fct de la valeur du saveConfigGrp.actionGroupEndIndex
                    // si start = end , on l'ajoute juste après
                    if(parseInt(newActGrp.actionGroupStartIndex) === parseInt(newActGrp.actionGroupEndIndex)){
                      itemPlacemark.actionGroup.push(endShotActGrp);
                    }
                    else{
                      // l'ajouter au début du bon step
                      endIntervalToAppend[parseInt(newActGrp.actionGroupEndIndex)] = endShotActGrp
                    }
                  }
                }
              }
            }
          }*/
        }
        else{
          // step vide (pas d'actions définies)

          itemPlacemark.actionGroup = new Array();

          // cas où un StopInterval doit être mis sur un step actuellement sans actions
          if(endIntervalToAppend[parseInt(itemPlacemark.index)] !== null && endIntervalToAppend[parseInt(itemPlacemark.index)] !== undefined){
            itemPlacemark.actionGroup.push(endIntervalToAppend[parseInt(itemPlacemark.index)]);
            delete endIntervalToAppend[parseInt(itemPlacemark.index)]
          }
        }
      })



      // met à jour les id avec cette nouvelle infra
      const copy = copyObject(lstPlacemark)
      const copyRecalc = this.updateID(copy);
      this.setPlacemark(templatekmz , copyRecalc);

      objReady = templatekmz;
      // console.log('after updateID', objReady);
    }
    else{
      // si template n'a pas de 'Placemark'
      objReady = templatekmz;
    }

    return objReady;
  }


  // une fois qu'on a fini les ajout, suppr, déplacés des Step et Action => met à jour les valeurs des ID/index
  updateID(arrPlacemark){
    // prend en paramètres le tableau Placemark et loop sur tous les items pour recalculer les différents indexes:
    // Placemark.index, actionGroup.actionGroupId, actionGroup.actionGroupStartIndex, actionGroup.actionGroupEndIndex, actionId

    let idxPlacemark = 0;
    let idxActionGrp = 0;
    let idxAction = 0;

    // on met à jour les différents indexs pour que ça corresponde au vrai index dans le tableau
    var copyPlacemark = new Array();
    // destructuring
    // shallow copy (clone the object, but keeping deep refences in the inner structure)
    for (const _placemark of arrPlacemark) {
      copyPlacemark.push(copyObject(_placemark));
    }


    copyPlacemark.forEach((itemPlacemark) =>{
      if(itemPlacemark !== undefined && itemPlacemark !== null){
        itemPlacemark.index = idxPlacemark;

        itemPlacemark.actionGroup.forEach((itemActGrp)=>{
          if(itemActGrp !== undefined && itemActGrp !== null){
            itemActGrp.actionGroupId = idxActionGrp;
            idxActionGrp++;

            itemActGrp.actionGroupStartIndex = idxPlacemark;
            itemActGrp.actionGroupEndIndex = idxPlacemark;

            itemActGrp.action.actionId = idxAction;
          }
        })

        idxPlacemark++;
      }
    })

    return copyPlacemark;
  }


  // on recalcule des index au moment du save KMZ
  // ici on est sur une infra d'objet différente
  // => tableau de Placemark
  // => tableau de actionGroup
  // => tableau de action
  updateIDWrite(arrPlacemark){
    // prend en paramètres le tableau Placemark et loop sur tous les items pour recalculer les différents indexes:
    // Placemark.index, actionGroup.actionGroupId, actionGroup.actionGroupStartIndex, actionGroup.actionGroupEndIndex, actionId

    let idxPlacemark = 0;
    let idxActionGrp = 0;
    // on met à jour les différents indexs pour que ça corresponde au vrai index dans le tableau
    var copyPlacemark = new Array();
    // destructuring
    // shallow copy (clone the object, but keeping deep refences in the inner structure)
    for (const _placemark of arrPlacemark) {
      copyPlacemark.push(copyObject(_placemark));
    }


    copyPlacemark.forEach((itemPlacemark) =>{
      if(itemPlacemark !== undefined && itemPlacemark !== null){
        itemPlacemark.index = idxPlacemark;

        itemPlacemark.actionGroup.forEach((itemActGrp)=>{
          if(itemActGrp !== undefined && itemActGrp !== null){
            itemActGrp.actionGroupId = idxActionGrp;
            idxActionGrp++;

            itemActGrp.actionGroupStartIndex = idxPlacemark;
            // on ne redéfinit pas le 'actionGroupEndIndex ', calculé en amont


            let idxAction = 0;
            if(Array.isArray(itemActGrp.action)){
              itemActGrp.action.forEach((action)=>{
                if(action !== undefined && action !== null){
                  action.actionId = idxAction;

                  idxAction++;
                }
              })
            }
            else{
              itemActGrp.action.actionId = idxAction;

              idxAction++;
            }

          }
        })

        idxPlacemark++;
      }
    })

    return copyPlacemark;
  }

  async xml2Kmz(xmltemplate, xmlwaylines, name) {
    let nameFile = name.toLowerCase().indexOf(this.extension) > -1 ? name : name + this.extension;

    if(xmltemplate != undefined) {
      this.template = xmltemplate;
    }
    if(xmlwaylines != undefined) {
      this.waylines = xmlwaylines;
    }


    let zipWriter = new zip.ZipWriter(new zip.BlobWriter("application/zip"));
    if(this.waylines) {
      // let jsonCoordsString = this.encodeJsonCoords(this.waylines);
      // let xml = this.jsonToXML(jsonCoordsString);
      let xml = xmlwaylines;

      const WAYLINES_BLOB = new Blob([xml], { type: "text/xml" });
      await zipWriter.add("wpmz/waylines.wpml", new zip.BlobReader(WAYLINES_BLOB));
    }
    if(this.template) {
      // let jsonCoordsString = this.encodeJsonCoords(this.template);
      // let xml = this.jsonToXML(jsonCoordsString);
      let xml = xmltemplate;

      const TEMPLATE_BLOB = new Blob([xml], { type: "text/xml" });
      await zipWriter.add("wpmz/template.kml", new zip.BlobReader(TEMPLATE_BLOB));
    }

    if(this.template && this.waylines){
      const Zip1 = await zipWriter.close();
      const mission_file = new File([Zip1], nameFile , {
        type: "application/vnd.google-earth.kmz",
      });
      return mission_file;
    }

    return undefined;
  }


/*
  async upload(filekmz, islocal) {

    if(islocal) {
      let url = window.URL.createObjectURL(mission_file);

      //create a hidden link and set the href and click it
      let a = document.createElement("a");
      a.style = "display: none";
      a.href = url;
      a.download = mission_file.name;
      a.click();
      window.URL.revokeObjectURL(url);
      return;
    }
    else{
      let r = await API.postFile(`mission?cmp_id=${$root.user.getCompany()}`, filekmz);
      if (Object.hasOwnProperty.call(r, "mis_id")) {
        return r;
      }
    }
  }*/

  // on limite les types de config KMZ possibles
  async verifFlight(file){
    try{
      const blob = new Blob([file], {type: "application/zip"});
      const templateUpload = await this.kmz2Json(blob);
      const isOK = this.checkTypeKMZ(templateUpload);

      let infos = {};

      if(isOK) {
        infos = this.getInfosVol(templateUpload)
        infos.typeroute = templateUpload.kml.Document.Folder.templateType
      }

      return { isOK: isOK, infos: infos };
    }
    catch(e){
      return false;
    }

  }

  checkTypeKMZ(templateUpload){
    // on vérifie si le type de route est bien 'waypoint'
    // + on vérifie si on est bien en Straight route

    if(
      this.isFolder(templateUpload) &&
      (
        (
          templateUpload.kml.Document.Folder.templateType === "waypoint" &&
          templateUpload.kml.Document.Folder.globalWaypointTurnMode === "toPointAndStopWithDiscontinuityCurvature"
        ) ||
        (
          templateUpload.kml.Document.Folder.templateType === "mapping2d"
        ) ||
        (
          templateUpload.kml.Document.Folder.templateType === "mappingPrism"
        )
      )
    ){
        return true;
      }
    else
      return false;
  }


  checkPayloadParam(templateUpload){
    // si le KMZ choisi ne contient pas la partie 'Folder.payloadParam', on l'ajoute à partir du Template
    if(!this.isPayloadParam(templateUpload)){
      templateUpload.kml.Document.Folder.payloadParam =  Object.assign({}, TemplateSuitePayloadParam, templateUpload.kml.Document.Folder.payloadParam);

      templateUpload.kml.Document.Folder.payloadParam.payloadPositionIndex = 0;

      const keyDroneCamera = ApiActions.getKeyDrone(templateUpload.kml.Document);
      templateUpload.kml.Document.Folder.payloadParam.imageFormat = CamSettings[keyDroneCamera].reduce((acc, item) => acc + (acc.length > 0 ? "," : "") + item.key, "");
    }

    return templateUpload;
  }


  async kmz2Json(blob) {
    const blobreader =  new zip.BlobReader(blob);
    // console.log("blobreader reader");
    const reader = new zip.ZipReader(blobreader);
    let gmlTemplate = await this.getAllEntryByName(reader, "wpmz/template.kml");
    // console.log('gmltemplate',gmlTemplate)
    let gmlWaylines = await this.getAllEntryByName(reader, "wpmz/waylines.wpml");
    // console.log('gmlWaylines',gmlWaylines)

    await reader.close();
    if(gmlTemplate) {

      const processors = xml2js.processors
      let parser = new xml2js.Parser({ explicitArray: false, tagNameProcessors :[processors.stripPrefix] });

      /*const result = await new Promise((resolve, reject) =>  parser.parseString(gmlTemplate,(err, result) => {
        if (err) reject(err);
        else resolve(result);
      }));*/
      const json = await parser.parseStringPromise(gmlTemplate);

      this.template = this.decodeJsonCoords(json);

      // console.log('template json', this.template);
    }
    if(gmlWaylines) {

      const processors = xml2js.processors
      let parser = new xml2js.Parser({ explicitArray: false, tagNameProcessors :[processors.stripPrefix] });

      const json = await parser.parseStringPromise(gmlWaylines);

      this.waylines = this.decodeJsonCoords(json);

      // console.log('gmlWaylines json', this.waylines);
    }

    return this.template;
  }

  jsonToXML(json) {

    json = this.addPrefixToKeys(json, "wpml:");
    var builder = new xml2js.Builder({
      xmldec: {
      'version': '1.0',
      'encoding': 'UTF-8',
      'standalone': null
      }
    });
    var xml = builder.buildObject(json);
    return xml;
  }

  isRealObject(obj) {
    return typeof obj === 'object' && obj !== null;
  }

  isNoTag(txt) {
    return this.noTags.indexOf(txt) === -1;
  }

  addPrefixToKeys(obj, prefix) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => {
        let prefixedValue = null;
        if(Array.isArray(v)){
          let arrKeys = new Array()
          v.forEach((itm)=>{
            arrKeys.push(this.addPrefixToKeys(itm, prefix))
          })
          prefixedValue = arrKeys
        }
        else if (this.isRealObject(v))
          prefixedValue =  this.addPrefixToKeys(v, prefix)
        else
          prefixedValue = v

        if(this.isNoTag(k)){
          return [prefix + k, prefixedValue];
        }
        else{
          return [k, prefixedValue];
        }

      })
    );
  }



  isDocument(json) {
    return json && json.kml && json.kml.Document;
  }

  isFolder(json) {
    return this.isDocument(json) && json.kml.Document.Folder;
  }

  isPlacemark(json) {
    return this.isFolder(json) && json.kml.Document.Folder.Placemark && json.kml.Document.Folder.Placemark.length > 0;
  }

  isPayloadParam(json) {
    return this.isDocument(json) && this.isFolder(json) && json.kml.Document.Folder.payloadParam;
  }

  setPlacemark(json, values)
  {
    if(this.isPlacemark(json)) {
      return json.kml.Document.Folder.Placemark = values;
    }
    return undefined;
  }


  getPlacemark(json)
  {
    if(this.isPlacemark(json)) {
      return json.kml.Document.Folder.Placemark;
    }
    return undefined;
  }

  getCoordinatesString(Placemark) {
    if(Placemark?.Point && Placemark?.Point?.coordinates) {
      if(!Array.isArray(Placemark.Point.coordinates)) {
        return Placemark.Point.coordinates.trim();
      }
    }
    return undefined;
  }

  getCoordinatesArray(Placemark) {
    if(Placemark.Point && Placemark.Point.coordinates) {
      return Placemark.Point.coordinates[0] + ", " + Placemark.Point.coordinates[1];
    }
    return undefined;
  }

  getellipsoidHeight(Placemark) {
    if(Placemark.ellipsoidHeight) {
      return parseFloat(Placemark.ellipsoidHeight);
    }
    return 0;
  }

  decodeJsonCoords(json) {

    const placemarks = this.getPlacemark(json);
    if(placemarks) {
      placemarks.forEach((placemark) => {
        const coordinates = this.getCoordinatesString(placemark);
        if(coordinates) {
          let PointCoords = [];
          const tabcoords = coordinates.split(",");
          if(tabcoords.length == 2){
            PointCoords.push(parseFloat(tabcoords[0].trim()));
            PointCoords.push(parseFloat(tabcoords[1].trim()));
            PointCoords.push(this.getellipsoidHeight(placemark));
          }
          placemark.Point.coordinates = PointCoords;
        }
      });
    }
    return json;
  }

  encodeJsonCoords(json) {
    const placemarks = this.getPlacemark(json);
    if(placemarks) {
      placemarks.forEach((placemark) => {
        const coordinates = this.getCoordinatesArray(placemark);
        placemark.Point.coordinates =coordinates;
      });
    }
    return json;
  }

  async getAllEntryByName(zipReader, name) {
    let entries = await zipReader.getEntries();
    let txt = "";
    let entry =  entries.filter((entry) => entry.filename == name);
    if(entry != undefined && entry.length == 1) {
        const firstentry = entry[0];
        const dataBlobWriter = new zip.BlobWriter("application/octet-stream");
        const data = await firstentry.getData(dataBlobWriter);
        txt = await data.text();
    }
    return txt;
  }

  getInfosVol(templateUpload){
    return ApiActions.getInfosVol(templateUpload.kml.Document);
  }

}

export default new FlightKmz();
